import { useState } from "react";
import { HiChevronRight } from "react-icons/hi";
import { PiPaperPlaneTiltBold } from "react-icons/pi";
import EmailViewModal from "./EmailViewModal";
import { EMAIL_TYPE_LABELS, EMAIL_TYPE_COLORS, EMAIL_TYPE } from "../../utils";

const CommunicationsSection = ({ emails = [], onSendEmail, disableEmailSending = false }) => {
  const [viewingEmail, setViewingEmail] = useState(null);

  const sortedEmails = [...emails].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

  const formatDate = (iso) =>
    new Date(iso).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <>
      <div className="mx-auto max-w-3xl px-6 py-4">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="section-title">
            <span>Emails</span>
            {emails.length > 0 && <span className="meta-badge bg-gray-100 text-gray-500">{emails.length}</span>}
          </h3>
        </div>

        {sortedEmails.length === 0 ? (
          <div className="rounded-lg border border-dashed border-gray-200 py-6 text-center text-xs text-gray-400">Aucun email envoyé</div>
        ) : (
          <div className="flex flex-col gap-2">
            {sortedEmails.map((email) => {
              const emailType = email.type || EMAIL_TYPE.CUSTOM;
              const colors = EMAIL_TYPE_COLORS[emailType] || EMAIL_TYPE_COLORS[EMAIL_TYPE.CUSTOM];
              return (
                <button
                  key={email._id}
                  type="button"
                  onClick={() => setViewingEmail(email)}
                  className="group flex w-full items-center gap-3 card px-3 py-2 text-left transition-colors hover:border-gray-200 hover:bg-gray-50"
                >
                  <div className="min-w-0 flex-1">
                    <div className="mb-1 flex items-center gap-2">
                      <span className={`meta-badge border ${colors.bg} ${colors.text} ${colors.border}`}>
                        {EMAIL_TYPE_LABELS[emailType] || emailType}
                      </span>
                      <span className="text-[11px] text-gray-400">{formatDate(email.createdAt)}</span>
                    </div>
                    <div className="truncate text-sm text-gray-900">{email.subject}</div>
                  </div>
                  <HiChevronRight className="h-4 w-4 shrink-0 text-gray-300 transition-colors group-hover:text-gray-500" />
                </button>
              );
            })}
          </div>
        )}

        {onSendEmail && (
          <button
            type="button"
            onClick={onSendEmail}
            disabled={disableEmailSending}
            className="mt-3 flex w-full items-center justify-center gap-2 rounded-md border border-dashed border-gray-300 bg-transparent px-3 py-2 text-xs text-gray-500 transition-colors hover:border-primary-400 hover:bg-primary-50 hover:text-primary-600 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-300"
          >
            <PiPaperPlaneTiltBold className="h-3.5 w-3.5" />
            Envoyer un email
          </button>
        )}
      </div>

      {viewingEmail && <EmailViewModal email={viewingEmail} onClose={() => setViewingEmail(null)} />}
    </>
  );
};

export default CommunicationsSection;
